import { Component } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subscription } from "rxjs";
import * as _ from "lodash";
import { ActivatedRoute, Router } from "@angular/router";
import { LogService } from "@rubbl-core";
import { SearchRequest, SearchResultsService } from "@rubbl-search-results";

@Component({
  selector: "app-search-results-filter-modal",
  templateUrl: "./search-results-filter-modal.component.html",
  styleUrls: ["./search-results-filter-modal.component.scss"],
})
export class SearchResultsFilterModalComponent {
  searchRequest: SearchRequest;
  searchRequestSubscription: Subscription;

  cachedSearchRequest: SearchRequest;
  loadingPrimaryTypes: boolean = false; // this is for hiding certain facets that when changing the primary type
  hasFiltered: boolean = false; // if this is set to false then we can just close the modal instead of refiltering with cached facet

  orderByDropDownItems = this.searchResultsService.searchRequest.orderBy.options;
  cachedQueryParams: any;

  constructor(
    private searchResultsService: SearchResultsService,
    private activeModal: NgbActiveModal,
    private router: Router,
    private route: ActivatedRoute,
    private logService: LogService,
  ) {
    this.searchRequestSubscription = this.searchResultsService.searchRequest$.subscribe((searchRequest: SearchRequest) => {
      this.searchRequest = searchRequest;
      this.loadingPrimaryTypes = false;
    });
  }

  ngOnInit(): void {
    this.cachedSearchRequest = _.cloneDeep(this.searchRequest);
    this.cachedQueryParams = this.cachedSearchRequest.toQueryParam();
  }

  ngOnDestroy() {
    this.searchRequestSubscription?.unsubscribe();
  }

  buyItNowOrRtoChange() {
    if (this.searchRequest.buyItNowEnabled.selected || this.searchRequest.rpoEnabled.selected) {
      this.searchRequest.location.selectedRadius = "anywhere";
    } else {
      this.searchRequest.location.selectedRadius = "250";
    }
    this.filter();
  }

  filterPrimaryType(type?: string) {
    this.loadingPrimaryTypes = true;
    this.searchRequest.onPrimaryTypeChange(type);
    this.filter();
    this.logService.pushTagToGtm({ event: "searchFilter", filterCategory: "Primary Type", filterSelection: type ? type : "Any" });
  }

  filterTypeDefinition(type: string) {
    this.searchRequest.onTypeDefinitionChange();
    this.filter();
    this.logService.pushTagToGtm({ event: "searchFilter", filterCategory: "Type Definition", filterSelection: type });
  }

  filterMake() {
    this.searchRequest.onMakeChange();
    this.filter();
  }

  filterModel() {
    this.searchRequest.onModelChange();
    this.filter();
  }

  cancelFilter() {
    if (this.hasFiltered) {
      // the user has filtered, we need to filter results by cached facets
      setTimeout(() => {
        // i really dont like using the cached query params. would like to just use the cached facets proeprty instead
        // and just call filterResults
        // to tired to figure out why it didnt work
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: this.cachedQueryParams,
          queryParamsHandling: "merge",
        });
      }, 250);
    }

    this.activeModal.close();
  }

  clearFilter() {
    this.activeModal.close();

    setTimeout(() => {
      this.searchRequest.facetsSetup = false;
      this.searchRequest.clearFilters();
      this.searchResultsService.filterResults();
    }, 250);
  }

  filter() {
    this.hasFiltered = true;
    this.searchResultsService.filterResults();
  }

  apply() {
    this.activeModal.close();
  }
}
